import 'react';
import '@tencent/workbench';
import '@tencent/dui/lib/components/Tooltip';
import '../components/form-items/angle/angle.less.js';
export { NumberInputFrom } from '../components/form-items/base/number-input.js';
import '../components/form-items/form-item.less.js';

/**
 * @public
 */
var ColorOperations;
(function (ColorOperations) {
    ColorOperations["COLOR_ENTER"] = "color-enter";
    ColorOperations["COLOR_LEAVE"] = "color-leave";
    ColorOperations["PANEL_LEAVE"] = "panel-leave";
})(ColorOperations || (ColorOperations = {}));

export { ColorOperations };
//# sourceMappingURL=form.interface.js.map
